import { useState } from 'react'

interface ImportSheetProps {
  isOpen: boolean
  onClose: () => void
  onFilePick: () => void
  onImportMarkdown: (markdown: string, name: string) => Promise<void>
}

export function ImportSheet({
  isOpen,
  onClose,
  onFilePick,
  onImportMarkdown,
}: ImportSheetProps) {
  const [name, setName] = useState('Pasted Markdown')
  const [markdown, setMarkdown] = useState('')

  if (!isOpen) {
    return null
  }

  return (
    <div className="sheet-backdrop" role="presentation" onClick={onClose}>
      <section
        className="import-sheet"
        role="dialog"
        aria-modal="true"
        aria-label="Import markdown"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="sheet-header">
          <div>
            <p className="eyebrow">Import</p>
            <h2>Open or paste markdown</h2>
          </div>
          <button type="button" className="ghost-button" onClick={onClose}>
            Close
          </button>
        </div>

        <div className="sheet-actions">
          <button type="button" className="primary-button" onClick={onFilePick}>
            Choose file
          </button>
          <p className="sheet-hint">You can also drag and drop a `.md` file anywhere in the app.</p>
        </div>

        <label className="sheet-field">
          <span>Document name</span>
          <input value={name} onChange={(event) => setName(event.target.value)} />
        </label>

        <label className="sheet-field">
          <span>Markdown</span>
          <textarea
            value={markdown}
            onChange={(event) => setMarkdown(event.target.value)}
            placeholder="# A quiet reading note"
          />
        </label>

        <div className="sheet-footer">
          <button
            type="button"
            className="primary-button"
            onClick={() => void onImportMarkdown(markdown, name)}
            disabled={!markdown.trim()}
          >
            Import text
          </button>
        </div>
      </section>
    </div>
  )
}
